import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import WithSidebar from 'Layout/WithSidebar';
import { LabelButton } from 'components/buttons/LabelButton/LabelButton';
import GradientText from 'components/GradientText';
import ProductItems from 'components/ProductItems';
import Banner from 'components/Banner';
import DefaultForm from 'components/FormSection/Forms/DefaultForm';
import {
    selectCropNutritionPage,
    fetchCropNutritionPage,
    selectCropNutritionPageCrops,
    selectAllCropNutritionOptions,
} from 'store/slices/CropNutritionSlice';
import { ROUTES } from 'constants/routes';
import { fetchCropNutritionPageCrops } from 'store/slices/CropNutritionSlice';
import { type_nutrition } from 'api/constants';
import NewDropdown from 'components/Dropdown';
import { selectProductsOptions } from 'store/slices/ProductsSlice';
import Filter from 'components/FilterNew';

const CropNutritionPrograms = () => {
    const dispatch = useDispatch();
    const {
        fs_title,
        fs_title_background,
        fs_view_button,
        agricultural_tag,
        agricultural_title,
        filter_name,
        crop_select,
        product_select,
    } = useSelector(selectCropNutritionPage);

    const crops = useSelector(selectCropNutritionPageCrops);

    useEffect(() => {
        // @ts-ignore
        dispatch(fetchCropNutritionPage());
        // @ts-ignore
        dispatch(fetchCropNutritionPageCrops({ type: type_nutrition, all: true }));
    }, [dispatch]);

    const productsOptions = useSelector(selectProductsOptions);
    const cropsOptions = useSelector(selectAllCropNutritionOptions);

    const [selectedProduct, setSelectedProduct] = useState(null);
    const [selectedCrop, setSelectedCrop] = useState(null);

    const handleProductsFilterChange = option => setSelectedProduct(option);
    const handleCropsFilterChange = option => setSelectedCrop(option);

    useEffect(() => {
        if (selectedProduct || selectedCrop) {
            dispatch(
                // @ts-ignore
                fetchCropNutritionPageCrops({
                    all: true,
                    type: type_nutrition,
                    product: selectedProduct?.value || null,
                    slug: selectedCrop?.value || null,
                }),
            );
        }
    }, [dispatch, selectedProduct, selectedCrop]);

    const handleReset = () => {
        setSelectedProduct(null);
        setSelectedCrop(null);
        // @ts-ignore
        dispatch(fetchCropNutritionPageCrops({ type: type_nutrition, all: true }));
    };

    const FilterComponent = () => (
        <Filter onReset={handleReset} hasSelected={selectedProduct || selectedCrop} title={filter_name}>
            <NewDropdown
                label={crop_select}
                options={cropsOptions}
                onChange={handleCropsFilterChange}
                selectedValue={selectedCrop}
            />
            <NewDropdown
                label={product_select}
                options={productsOptions}
                onChange={handleProductsFilterChange}
                selectedValue={selectedProduct}
            />
        </Filter>
    );

    return (
        <>
            <Banner title={fs_title} image={fs_title_background} buttonText={fs_view_button} />

            <section className="container">
                <div className="inner-container type-3">
                    <div className="main-text-container">
                        <LabelButton>{agricultural_tag}</LabelButton>
                        <GradientText>
                            <span dangerouslySetInnerHTML={{ __html: agricultural_title }} />
                        </GradientText>
                    </div>
                </div>

                <WithSidebar Sidebar={<FilterComponent />}>
                    <div className="box">
                        <ProductItems data={crops} baseRoute={ROUTES.cropNutritionPrograms} />
                    </div>
                </WithSidebar>
            </section>

            <DefaultForm />
        </>
    );
};

export default CropNutritionPrograms;
